/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Loading_Upload_ProgressInputs */

const en_loading_upload_progress = /** @type {(inputs: Loading_Upload_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.total} files uploaded`)
};

const id_loading_upload_progress = /** @type {(inputs: Loading_Upload_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} dari ${i?.total} berkas berhasil diunggah`)
};

/**
* | output |
* | --- |
* | "{done} of {total} files uploaded" |
*
* @param {Loading_Upload_ProgressInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_upload_progress = /** @type {((inputs: Loading_Upload_ProgressInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Upload_ProgressInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_upload_progress(inputs)
	return en_loading_upload_progress(inputs)
});